import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENDPOINTS } from '@shared/constants';
import { CommonResponseDTO, IWorkflowBOMS } from '@shared/interfaces';
import { generateURL } from '@shared/utils';

@Injectable({
  providedIn: 'root',
})
export class WorkflowsBOMSService {
  constructor(private http: HttpClient) {}

  public getAllWorkflows(
    params?: HttpParams
  ): Observable<CommonResponseDTO<IWorkflowBOMS[]>> {
    const url = generateURL({ endpoint: ENDPOINTS.WORKFLOWS_GET_ALL });
    const config = { params };

    return this.http.get<CommonResponseDTO<IWorkflowBOMS[]>>(url, config);
  }

  public createWorkflow(
    workflow: IWorkflowBOMS
  ): Observable<CommonResponseDTO<IWorkflowBOMS>> {
    const url = generateURL({ endpoint: ENDPOINTS.WORKFLOWS_ADD_NEW });
    return this.http.post<CommonResponseDTO<IWorkflowBOMS>>(url, workflow);
  }

  public getWorkflow(id: string): Observable<CommonResponseDTO<IWorkflowBOMS>> {
    const url = generateURL({
      endpoint: ENDPOINTS.WORKFLOWS_GET_ONE,
      params: { id },
    });
    return this.http.get<CommonResponseDTO<IWorkflowBOMS>>(url);
  }

  public updateWorkflow(
    data: IWorkflowBOMS,
    id: string
  ): Observable<CommonResponseDTO<IWorkflowBOMS>> {
    const url = generateURL({
      endpoint: ENDPOINTS.WORKFLOWS_UPDATE_ONE,
      params: { id },
    });
    return this.http.put<CommonResponseDTO<IWorkflowBOMS>>(url, data);
  }

  public deleteWorkflow(
    id: string
  ): Observable<CommonResponseDTO<IWorkflowBOMS>> {
    const url = generateURL({
      endpoint: ENDPOINTS.WORKFLOWS_DELETE_ONE,
      params: { id },
    });
    return this.http.delete<CommonResponseDTO<IWorkflowBOMS>>(url);
  }
  public restoreWorkflow(
    id: string
  ): Observable<CommonResponseDTO<IWorkflowBOMS>> {
    const url = generateURL({
      endpoint: ENDPOINTS.WORKFLOWS_RESTORE_ONE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IWorkflowBOMS>>(url, {});
  }

  public disableWorkflow(
    id: string
  ): Observable<CommonResponseDTO<IWorkflowBOMS>> {
    const url = generateURL({
      endpoint: ENDPOINTS.WORKFLOWS_DISABLE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IWorkflowBOMS>>(url, {});
  }
  public enableWorkflow(
    id: string
  ): Observable<CommonResponseDTO<IWorkflowBOMS>> {
    const url = generateURL({
      endpoint: ENDPOINTS.WORKFLOWS_ENABLE,
      params: { id },
    });
    return this.http.patch<CommonResponseDTO<IWorkflowBOMS>>(url, {});
  }
}
